export default __webpack_public_path__ + "579c181b24896085dd6e5c8fdd1b6b97.png";